import { CurrenciesContext } from '@/currencies/currency.context';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { NavigationProp } from '@react-navigation/native';
import * as Linking from 'expo-linking';
import { useContext } from 'react';
import { Platform } from 'react-native';

export const toNumber = (input: string | number | undefined | null): number => {
  return Number(input?.toString()?.replace(/[^-.0-9]/g, '') ?? 0);
};

export const isAmountValid = (input: string | number | undefined | null): boolean => {
  if (input === undefined || input === null || input === '') {
    return false;
  }

  const length = input?.toString().match(/^[+-]?(([0-9]+)([,.])*)+/) ? input.toString().length : 0;
  return length > 0;
};

export const isAmountPositive = (input: string | number | undefined | null): boolean => {
  return isAmountValid(input) && toNumber(input) > 0;
};

export const mapUrlLink = (url: string): { parentName: string; subName: string } => {
  const { path } = Linking.parse(url);
  if (!path) return { parentName: '', subName: '' };
  let splitPath = path?.split('/');
  const parentName = `${splitPath[0]}`;
  const subName = `${splitPath[1]}`;
  return { parentName, subName };
};

export const onGoBack = (navigation: NavigationProp<ReactNavigation.RootParamList>) => {
  if (navigation.canGoBack()) {
    navigation.goBack();
    // if (Platform.OS === 'web') {
    //   window.history.back();
    // } else {
    //   navigation.goBack();
    // }
  }
};

export const openURL = async (url: string) => {
  if (Platform.OS == 'web') {
    window.open(url, '_blank');
  } else {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    }
  }
};

export const openImage64 = (url64: string) => {
  let image = new Image();
  image.src = url64;
  const newTab = window.open();
  if (newTab) newTab.document.body.innerHTML = image.outerHTML;
};

export const displayAmountWithCurrency = (amountString: string, currency: string): string => {
  const { getDecimalByAsset } = useContext(CurrenciesContext);
  const amount = parseFloat(amountString);
  return `${amount < 0 ? '-' : ''}${formatAmountByDecimals({
    value: Math.abs(amount),
    decimals: getDecimalByAsset(currency),
    suffix: currency
  })}`;
};

export const getCJKCharactersLength = (str: string): number => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    /[\u4e00-\u9fff]/g.test(str[i]) ? (len += 2) : len++;
  }
  return len;
};

export const getCJKCharacters = (str: string, length: number): string => {
  let len = 0;
  let strFlag = '';
  for (let i = 0; i < str.length; i++) {
    if (/[\u4e00-\u9fff]/g.test(str[i])) {
      len += 2;
      if (len > length) {
        break;
      } else {
        strFlag += `${str[i]}`;
      }
    } else {
      len++;
      if (len > length) {
        break;
      } else {
        strFlag += `${str[i]}`;
      }
    }
  }
  return strFlag;
};
